import * as React from "react";
import classNames from "classnames";

export interface ITab {
    key: string;
    label: string;
    content: React.ReactNode;
}

export interface ITabsProps {
    render(state: ITabsRenderProps): React.ReactNode;
    defaultTab: ITab;
    className?: string;
}

interface ITabsRenderProps {
    readonly tabClickHandler: () => void;
    readonly selectedTabKey: string;
}

class Tabs extends React.Component<ITabsProps> {
    public state = {
        selectedTabKey: this.props.defaultTab.key
    };

    private tabClickHandler = (tabId: string) => {
        this.setState({
            selectedTabKey: tabId
        });
    };

    public getRenderProps(): ITabsRenderProps {
        return {
            tabClickHandler: this.tabClickHandler.bind(this),
            selectedTabKey: this.state.selectedTabKey
        };
    }

    public render() {
        const renderProps = this.getRenderProps();
        const rootClasses = classNames("tabs", this.props.className);

        return <div className={rootClasses}>{this.props.render(renderProps)}</div>;
    }
}

export default Tabs;
